export default "__VITE_ASSET__620838a1__"